import React  from 'react';
import PowerShadesTypeahead from '../Parts/PowerShadesTypeahead';
import { useQuoteById } from '../Store/entities/quotes/hooks';
import { useTerritories } from '../Store/entities/hooks';
import { UsePortalDispatch } from '../Store';
import { updateQuoteTerritoryId } from '../Store/entities/quotes';

type TerritoryAssignProps = {
	quoteId: number;
	isEditable: boolean;
	className?: string;
	extraMargin?: boolean;
}

const TerritoryAssign = ({
	quoteId,
	isEditable,
	className,
	extraMargin
}: TerritoryAssignProps) => {

	const quote = useQuoteById(quoteId);
	const territoryId = quote.territory_id ?? 0;
	const dispatch = UsePortalDispatch();

	const territories = useTerritories();

	const changedTerritory = (newTerr) => {
		const selectedTerritory = newTerr[0] ?? { value: 0 };
		
		dispatch(updateQuoteTerritoryId({
			quoteId,
			territoryId: selectedTerritory.value
		}))
	};

	const options = territories
		.map((territory) => ({ label: territory.name, value: territory.id }))
		.sort((s1, s2) => s1.label.localeCompare(s2.label));

	const currentTerritory = territories.find((territory) => territoryId=== territory.id);

	const transformedTerritory = currentTerritory
		? { label: currentTerritory.name, value: currentTerritory.id }
		: { label: '', value: 0 };

	return (
		<div className={`${className} ${extraMargin ? 'mb-1' : null}`} style={{ width: '100%', marginTop: '0.5em' }}>
			<label className={extraMargin ? 'mb-1' : ''} htmlFor='territory-assign'>Territory</label>
			<br />
			<PowerShadesTypeahead
				clearButton
				id="territory-assign"
				options={options}
				// value={
				// 	currentTerritory
				// 		? { label: currentTerritory.name, value: currentTerritory.id }
				// 		: null
				// }
				selected={currentTerritory ? [transformedTerritory] : []}
				onChange={(newTerr) => changedTerritory(newTerr)}
				disabled={!isEditable}
				placeholder="Assign to Territory"
			/>
		</div>
	);
};

export default TerritoryAssign;
